import { LeadFormLinks } from "types/LeadForm"
import { createRemoteReducer, RemoteReducer } from "types/Remote"

export const linksReducer: RemoteReducer<LeadFormLinks> =
  createRemoteReducer("links")
